import React, { useEffect, useState } from "react";
import { LinkItem } from "@sharedComponents/AToZContainer/types";
import AToZContainer from "@sharedComponents/AToZContainer/AToZContainer";
import { I18nextProvider } from "react-i18next";
import i18n from "@apps/Shared/translation/i18n";
import { getLocale } from "@apps/Shared/Utils/Utils";
import { useGetAtoZItemsQuery } from "@apps/Shared/GraphQL/generated";
import LoadingIndicator from "@sharedComponents/LoadingIndicator";

function App(): JSX.Element {
    const [allLinks, setAllLinks] = useState<LinkItem[]>([]);
    const [skip, setSkip] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [hasMoreItems, setHasMoreItems] = useState(true);

    const locale = getLocale();
    const { data } = useGetAtoZItemsQuery({
        locale: [locale],
        skip: skip,
    });

    function cmsToLinkItem(item: any): LinkItem | null {
        if (item?.Name && item?.RelativePath) {
            return {
                name: item.Name,
                url: item.RelativePath,
            };
        }
        return null;
    }

    useEffect(() => {
        if (data?.Content?.items && data.Content?.total && hasMoreItems) {
            const totalFetched = skip + data.Content.items.length;

            const newItems = data.Content.items
                .map(cmsToLinkItem)
                .filter((item): item is LinkItem => item !== null);

            setAllLinks(prevLinks => [...prevLinks, ...newItems]);
            if (totalFetched < data.Content.total) {
                setSkip(totalFetched);
            } else {
                setIsLoading(false);
                setHasMoreItems(false);
            }
        }
    }, [data, hasMoreItems]);

    return (
        <I18nextProvider i18n={i18n}>
            {isLoading ? (
                <LoadingIndicator />
            ) : (
                <AToZContainer allLinks={allLinks} />
            )}
        </I18nextProvider>
    );
}

export default App;
